export default [
    {path: ':analysis_year_id'},
    {path: ':analysis_year_id/edit/:item_id'} ,
    {path: ':analysis_year_id/details/:item_id'} ,
]